import { createFileRoute } from '@tanstack/react-router'
import { LegalIndexPage } from '../components/legal/LegalPage'

// `/about` — the public legal section (spec 2026-09-09-02). It lives outside
// routes/$org and inherits no auth guard: the reader has no account and no
// organization, which is exactly who legal documents are written for.
export const Route = createFileRoute('/about/')({
    component: LegalIndexPage,
})
